import React, {useEffect, useState} from 'react';

import styles from './DeliveryCourierAddress.module.css'

import {Input} from "../../../../../../../../ui/DataEntry/Input/Input.tsx";
import {cn} from "../../../../../../../../utils/cn.ts";
import {TextArea} from "../../../../../../../../ui/DataEntry/TextArea/TextArea.tsx";
import {Order} from "../../../../../../../../types/Order.interface.ts";
import {Address} from "../../../../../../../../types/Delivery.interface.ts";
import {Map, Placemark, YMaps} from "@pbe/react-yandex-maps";
// import { useMultiStorage } from '../../../../../../../../hooks/useStorage.ts';
import { API_URL } from '../../../../../../../../config.tsx';
import { RootState, useAppSelector } from '@/utils/storage/stores/store.ts';

interface Props {
    onCourierAddressChange: (address: Address) => void
}
interface PropsMapBlock {
    latitude: number,
    longitude: number,
}

const MapBlock: React.FC<PropsMapBlock> = ({latitude, longitude}) => {
    const [center, setCenter] = useState<[number, number]>([latitude, longitude]);
    const mapState = React.useMemo(() => ({ center, zoom: 16, controls: [], }), [center]);

    useEffect(() => {
        setCenter([latitude, longitude]);
    }, [latitude, longitude]);
    return (
        <div>
            <YMaps>
                <Map
                    state={mapState}
                    width="100%"
                    height={485}
                >
                    <Placemark
                        modules={["geoObject.addon.balloon"]}
                        geometry={center}
                    />
                </Map>
            </YMaps>
        </div>
    )
}
export const DeliveryCourierAddress: React.FC<Props> = ({onCourierAddressChange}) => {
    const [offer, setOffer] = useState<Order|null>(null);
    const [latitude, setLatitude] = useState<number|null>(null);
    const [longitude, setLongitude] = useState<number|null>(null);
    const cartOffer = useAppSelector((state: RootState) => state.cart.cartOffer);
    // const storage = useMultiStorage({
        // cartOffer: ['cartOffer', offer],
    //   })[0];

    const [postcode, setPostcode] = useState<string>('');
    const [city, setCity] = useState<string>('');
    const [townId, setTownId] = useState<number>(0);
    const [street, setStreet] = useState<string>('');
    const [streetNumber, setStreetNumber] = useState<string>('');
    const [apartmentNumber, setApartmentNumber] = useState<string>('');
    const [comment, setComment] = useState<string>('');

    const changeDeliveryComment = (comment: string) => {
        if(!offer) return;
        setComment(comment);
        fetch(`${API_URL}/cart/${offer.cartId}/change_delivery_comment`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({comment}),
        })
    }

    const changeStreet = (street: string) => {
        setStreet(street);
        onCourierAddressChange({postcode, city, townId, street, streetNumber, apartmentNumber});
    }

    const changeStreetNumber = (streetNumber: string) => {
        setStreetNumber(streetNumber);
        onCourierAddressChange({postcode, city, townId, street, streetNumber, apartmentNumber});
    }

    const changeApartmentNumber = (apartmentNumber: string) => {
        setApartmentNumber(apartmentNumber);
        onCourierAddressChange({postcode, city, townId, street, streetNumber, apartmentNumber});
    }

    useEffect(() => {
        if(cartOffer) {
            setOffer(cartOffer);
            if(cartOffer.delivery.latitude) setLatitude(cartOffer.delivery.latitude);
            if(cartOffer.delivery.longitude) setLongitude(cartOffer.delivery.longitude);
            setStreet(cartOffer.delivery.street || '');
            setStreetNumber(cartOffer.delivery.house || '');
            setApartmentNumber(cartOffer.delivery.apartment || '');
            setComment(cartOffer.delivery.comment || '');
            setPostcode(cartOffer.delivery.postcode || '');
            setCity(cartOffer.delivery.townName || '');
            setTownId(cartOffer.delivery.townId || 0);
        }
    }, [cartOffer]);

    if(!offer) return null;

    return (
        <div>
            <div style={{marginBottom: 12,}}>
                <h4 className={styles.title}>Адрес доставки</h4>
                <div className={styles.inputs}>
                    <Input
                        className={cn(styles.input, styles.street)}
                        label='Улица'
                        value={street}
                        changeStateValue={changeStreet}
                    />
                    <Input
                        className={cn(styles.input, styles.streetNumber)}
                        label='Дом'
                        value={streetNumber}
                        changeStateValue={changeStreetNumber}
                    />
                    <Input
                        className={cn(styles.input, styles.apartmentNumber)}
                        label='Кв./Офис'
                        value={apartmentNumber}
                        changeStateValue={changeApartmentNumber}
                    />
                </div>
            </div>
            {
                latitude && longitude
                    ? <MapBlock latitude={latitude} longitude={longitude} />
                    : null
            }
            <div className={styles.inputs} style={{marginTop: 12,}}>
                <TextArea value={comment} onInput={changeDeliveryComment} />
            </div>
        </div>
    );
};
